import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderDataRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("WorkOrderData");
